import {connect} from 'react-redux'
import {EditorHeader} from 'report-components'
import {getItems, getPatientName, getSelectedTemplate} from 'report-components/lib/selectors'
import {saveTemplate, autoSaveUpdate, autoSaveRemove, autoSaveOrder, autoSaveRetry} from 'report-components/lib/reducers'

const getAvailableSignatures = getItems()

const prepareTemplateToSave = ({templateId, label, keepContent, keepSignatures}) => (report) => {
  const {reportSignatures, reportFields, reportBasicInfos, reportTitle} = report
  const withoutId = ({id, ...obj}) => obj
  const withoutModified = ({modified, ...obj}) => obj
  const withoutIsCustom = ({isCustom, ...obj}) => obj
  const toList = (map) => map.order.map(id => withoutModified(withoutId(map[id])))
  return {
    id: templateId,
    label,
    fields: {
      reportSignatures: keepSignatures ? toList(reportSignatures).map(withoutIsCustom) : [],
      reportFields: keepContent ? toList(reportFields) : toList(reportFields).map(({value, ...field}) => ({
        ...field,
        value: ''
      })),
      reportBasicInfos: toList(reportBasicInfos).map(({value, ...info}) => ({
        ...info,
        value: ''
      })),
      reportTitle: {title: reportTitle.title}
    }
  }
}

export const ReportEditorHeader = connect(({report, appUI}) =>  ({
    lastSaved: report.lastSaved,
    isRetryNotificationOpen: report.appUI.retryAutoSave,
    isSaving: appUI.loadings[autoSaveUpdate] || appUI.loadings[autoSaveRemove] || appUI.loadings[autoSaveOrder] || appUI.loadings[autoSaveRetry],
    selectedTemplate: getSelectedTemplate(report),
    dicomInfo: report.dicomInfo,
    templates: report.templates,
    availableSignatures: getAvailableSignatures(report.availableSignatures),
    reportTitle: report.reportTitle,
    studies: report.dicomInfo.studies,
    readOnly: report.readOnly,
    patientName: getPatientName(report),
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat,
    prepareTemplateToSave
  }),
  dispatch => ({
    saveTemplate: (fn) => dispatch((dispatch, getState) => saveTemplate(fn(getState().report))(dispatch))
  })
)(EditorHeader)


// WEBPACK FOOTER //
// ./src/javascripts/report/ReportEditorHeader.jsx